import { aemPdfLinks } from '../shared/Links';

export const adviceFundsList = [
    'TRBCX',
    'PRXCX',
    'PRPIX',
    'PRIJX',
    'PRMSX',
    'PRFDX',
    'PREIX',
    'PEXMX',
    'GTFBX',
    'RPIHX',
    'PRSNX',
    'PRGMX',
    'PRGFX',
    'PIEQX',
    'TNIBX',
    'TRBFX',
    'MDXBX',
    'PRCIX',
    'NJTFX',
    'PRNYX',
    'TROSX',
    'TQSMX',
    'PRWBX',
    'PREFX',
    'PRFHX',
    'PRTAX',
    'PRFSX',
    'PBDIX',
    'TUHYX',
    'TRBUX',
    'PRCOX',
    'PRTXX',
    'TRVLX',
    'PRVAX',
    'RPIEX',
    'PREMX',
    'PRTIX',
    'PRULX',
    'TSCXX',
    'PRRXX',
    'TSDLX',
    'PRNHX',
    'RPMGX',
    'TRGOX',
    'PRDGX',
    'TRULX',
    'TRLUX',
    'PRSVX',
    'TRMCX',
    'OTCFX',
    'PRDMX',
    'PRDSX',
    'PSILX',
    'PRAFX',
    'PRULX',
    'PRELX',
    'PRFRX',
    'TRGRX',
    'RPIBX',
    'PRNEX',
    'TRREX',
    'TQMVX',
    'PRHSX',
    'PRISX',
    'PRSCX',
    'PRGTX',
    'PRMTX',
    'PRITX',
    'TRIGX',
    'TRECX',
];

export const etfTickers = ['TGRT', 'TCAF', 'TVAL', 'TMSL', 'TOUS', 'TAGG'];

export const acctSelHeader =
    'Confirm the account(s) to include in your Financial Plan and Retirement Income Plan (if applicable)';

export const KeypointsContent = {
    header: `In this step, we identify important information you should know about the
             <span style="white-space: nowrap"}> T. Rowe Price</span> Retirement Advisory Service&trade; (Service).`,
    headerId: 'key-points-info-header',
    listHeader: `By enrolling in the Financial Planning and Retirement Income Planning (collectively,
                <span style="font-weight: bold">Planning</span>) portion of the Service, you:`,
    terms: 'The full terms and conditions are provided in the Client Agreement and Planning Supplement.',
    checbkoxLabel: 'I understand the Key Points',
    consent: [
        {
            keyPoint: '1',
            consentText: `Authorize <span style="white-space: nowrap">T. Rowe Price</span> Advisory Services,
                              Inc. (<span style="font-weight: bold">TRP Advisory Services</span>) to
                              provide nondiscretionary, point-in-time financial planning, asset allocation advice and a
                              recommended model portfolio consisting of proprietary products (<span style="font-weight: bold">Financial Plan</span>) to you
                              through the Service;`,
            id: 'key-point-1',
        },
        {
            keyPoint: '2',
            consentText: `Understand that the fund recommendations in the model portfolio will consist solely of selected
                                <span style="white-space: nowrap">T. Rowe Price</span> mutual funds and exchange-traded funds
                                (<span style="font-weight: bold">Price Funds</span>),
                                which are subject to market risk, including possible loss of principal;`,
            id: 'key-point-2',
        },
        {
            keyPoint: '3',
            consentText: `Understand that if you implement the fund recommendations on your own and invest in Price Funds,
                                affiliates of TRP Advisory Services will earn compensation through the management and/or other fees of the
                                Price Funds in which you invest;`,
            id: 'key-point-3',
        },
        {
            keyPoint: '4',
            consentText: `Understand that if you enroll in the Discretionary Management portion of the Service and meet certain eligibility requirements,
                                you authorize TRP Advisory Services to provide nondiscretionary, point-in-time retirement income planning
                                (<span style="font-weight: bold">Retirement Income Plan</span>) to you through the Service;`,
            id: 'key-point-4',
        },
        {
            keyPoint: '5',
            consentText: `Understand that the Financial Plan, including the recommended model portfolio, and the Retirement Income Plan
                                are point-in-time recommendations based on the information you provide and the assumptions disclosed to you,
                                and do not account for any subsequent changes to your financial planning or retirement or other goals,
                                risk tolerance, time horizon, or financial circumstances;`,
            id: 'key-point-5',
        },
        {
            keyPoint: '6',
            consentText: `Understand that you are not obligated to accept the advice or recommendations provided in the Financial Plan or
                                Retirement Income Plan;`,
            id: 'key-point-6',
        },
        {
            keyPoint: '7',
            consentText: `Understand that you are responsible for implementing the Financial Plan and Retirement Income Plan and that
                                TRP Advisory Services will not take any action to implement, review or update the Financial Plan or
                                Retirement Income Plan, and will not invest, manage or monitor any of your assets unless and to the extent
                                you enroll in the Discretionary Management portion of the Service; and`,
            id: 'key-point-7',
        },
        {
            keyPoint: '8',
            consentText: `Understand that if you do not enroll in the Discretionary Management portion of the Service, the TRP Advisory Services
                                Client Agreement and Retirement Advisory Service Financial Planning and Retirement Income Planning Supplement
                                (<span style="font-weight: bold">Client Agreement and Planning Supplement</span>) expire and terminate 90 calendar days after you enroll
                                in the Planning portion of the Service.`,
            id: 'key-point-8',
        },
    ],
};

export const EDeliveryConsentContent = {
    header: 'In this step, you authorize us to electronically deliver documents and disclosures to you, which is a requirement of the Service.',
    headerId: 'electronic-consent-info-header',
    checkboxLabel: 'I agree to the Consent to Electronic Access and Delivery',
    consent: [
        {
            key: '1',
            consentText: `I consent to accept electronic delivery (as available) of all communications, documents and disclosures, associated with
            the Planning portion of the Service (collectively, <span style="font-weight: bold">Service Communications</span>) and all applicable updates, modifications and
            amendments of these Service Communications
            (as further described in Section 9 of the <a
                id="client-agreement-pdf"
                href="https://www.troweprice.com/content/dam/iinvestor/advice/retirement-advisory-service/t-rowe-price-discretionary-management-supplement-client-agreement.pdf"
                target="_blank"
                style="text-decoration: underline; color: #086EA1"
              >
              <span style="white-space: nowrap">T. Rowe Price</span> Advisory Services, Inc. Client Agreement</a>). I understand that accepting electronic delivery of the
              documents and disclosures necessary to enroll and participate in the Service (<span style="font-weight: bold">Service Enrollment Documents</span>)
              means that they are legally binding and are considered to have been “signed” by me with the same effect as a manual signature. I agree not to dispute
              the validity or enforceability of any of the terms of the Service Enrollment Documents electronically accepted or entered into by me
              (or by anyone using my authentication devices, such as a password or PIN).`,
            id: 'electronic-consent-1',
        },
        {
            key: '2',
            consentText: `I understand that I will receive an email from the Service or Pershing (the Service’s clearing firm) to the email address
            <span style="white-space: nowrap">T. Rowe Price</span> has on file for me containing a URL link to access Service Communications. I understand that it is my
            obligation to maintain an accurate and up-to-date email address and to ensure that I have the ability to read, download, print and retain all Service Communications
            I wish to retain. I may view, verify, and change my email address at any time via the Service’s website. I understand that my participation in the Service may be
            terminated if I do not maintain an accurate and up-to-date email address with the Service. I acknowledge that I may request a paper copy of individual Service
            Communications at any time by contacting my financial advisor.`,
            id: 'electronic-consent-2',
        },
        {
            key: '3',
            consentText: `By agreeing to this Consent to Electronic Access and Delivery, I affirm that I have provided a valid email address to
            <span style="white-space: nowrap">T. Rowe Price</span> and am of legal age to enter into a contract in my state of residence. I agree that electronic delivery of
            the Service Enrollment Documents and Service Communications is deemed accepted, regardless of whether I access or view a particular document or communication. This
            Consent to Electronic Access and Delivery is effective until revoked. I understand that I may revoke my consent at any time by contacting my advisor, but that if I
            do so, TRP Advisory Services, in its sole discretion, will terminate my participation in and unenroll me from the Service.`,
            id: 'electronic-consent-3',
        },
    ],
};

export const ProspectusesContent = {
    header: `In this step, we share the prospectus for each
            <span style={{ whiteSpace: 'nowrap' }}> T. Rowe Price</span> mutual fund and exchange-traded fund (ETF) that could be included in your
            recommended portfolio.`,
    headerId: 'prospectuses-info-header',
    subTitle: `Prospectuses for Available Funds`,
    subHeader: `The prospectuses below detail the objectives, performance, risks, and fees of the
                <span style={{ whiteSpace: 'nowrap' }}> T. Rowe Price</span> mutual funds and ETFs
                that can be recommended through the Service.`,
    checkboxLabel: 'I received the prospectuses for the funds used in the Service',
};

export const ClientAgrContent = {
    header: `In this step, you agree to the Client Agreement and Planning Supplement that govern your
                          relationship with <span style="white-space: nowrap">T. Rowe Price</span>
                          for the Planning portion of the Service. We also provide important disclosure documents
                          that contain information about the Service, our business practices and the nature
                          of your relationship with <span style="white-space: nowrap">T. Rowe Price.</span>`,
    headerId: 'fps-agreement-info-header',
    includeInvestmentRelease: `By clicking “I agree” below, you agree to the terms and conditions of the Client Agreement and Planning Supplement
             and acknowledge receipt of the ADV for the Retirement Advisory Service,
             the Forms CRS for TRP Advisory Services and <span style="white-space: nowrap">T. Rowe Price</span> Investment Services, Inc.
             (<span style="font-weight: bold">TRP Investment Services</span>), and the T. Rowe Price Privacy Notice.`,
    authorizeInvHoldings: `You may want to print or save a copy of these documents for your records. If you have any questions or concerns or would like a paper copy of any
        of these documents, please call 1-800-225-5132 on weekdays between 8:00 AM and 8:00 PM ET.`,
};

export const InvestmentInfoContent = {
    header: `In this step, you will identify the accounts to include in your Financial Plan and (if applicable) Retirement Income Plan
                                (collectively, <span style="font-weight: bold">Plan</span>). The same accounts that you include in your Financial Plan will automatically be included in your Retirement
                                Income Plan (if applicable), except for any other accounts you ask us to exclude from the Retirement
                                Income Plan. Including more of your accounts gives us a fuller picture of your entire financial situation and will help us create a Plan
                                more tailored to your financial situation and goals.`,
    explanation: `Your <span style="white-space: nowrap">T. Rowe Price</span> Mutual Fund and Brokerage investments in IRA and taxable accounts will
                                automatically be included. If you have eligible <span style="white-space: nowrap">T. Rowe Price</span> Workplace Retirement
                                and/or Trust accounts, you just need to authorize us to include them. These types of accounts may not, however,
                                be eligible for discretionary management. You may also include investment accounts held with another financial institutions in your Plan
                                by using an aggregation service to link those accounts. You can always manually enter outside investments into your plan, as well.`,
    note: `Please note that certain types of accounts that you may control, like irrevocable trusts or corporate accounts, cannot be included in your
                                Plan. The only type of trust that we can provide advice for is certain revocable trusts. If you have questions, please discuss them with your
                                financial advisor.`,
    headerId: 'investment-info-header',
    longNote: `Please note that certain types of accounts that you may control, like irrevocable trusts or corporate accounts, cannot be included in your Plan.
                Other types of accounts, like workplace retirement accounts, can be included in the Plan but are not eligible for discretionary management. Please
                note that the only type of trust that we can provide advice for are certain revocable trusts. Please discuss with your financial advisor if you have questions.`,

    authorize: `By clicking the checkbox(es) below, I authorize investment holdings
                information from my workplace retirement account(s) and/or trust account(s) to be included in the <span style="font-weight: bold">Plan</span> to the extent this
                account/these accounts are serviced by affiliates of <span style="white-space: nowrap">T. Rowe Price</span> Advisory Services.`,
    mutualFundSection: [
        {
            key: `1`,
            contentHeader: `<span style="white-space: nowrap">T. Rowe Price</span> Mutual Fund and Brokerage Investments in IRA and/or Taxable Accounts`,
            content: `The mutual funds and brokerage investments in IRA and/or taxable accounts you own
                    and can act on at <span style="white-space: nowrap">T. Rowe Price</span> will be included in your
                    Plan by default, but you can choose to exclude any of them. You can optionally include any external account(s) in your Plan.`,
            id: 'authorization-explanation-1',
            contentEligible: `The mutual funds and brokerage investments in IRA and/or taxable accounts you own
                    and can act on at <span style="white-space: nowrap">T. Rowe Price</span> will be included in your
                    Plan by default, but you can choose to exclude any of them. You can optionally include any external account(s) in your Plan.`,
            className: 'authorizationExplanation',
        },
        {
            key: `2`,
            content: `If you do not want to include your workplace retirement account(s) in your Plan, click “I Agree to the Terms of Service” to continue.`,
            contentEligible: `If you do not want to include your workplace retirement account(s) in your Plan, click “I Agree to the Terms of Service” to continue.`,
            id: 'authorization-explanation-2',
            className: 'authorizationExplanationSub',
        },
    ],

    workplaceTrustSection: {
        header: `<span style="white-space: nowrap">T. Rowe Price</span> Workplace Retirement and Trust Accounts`,
        content: `You must authorize us to include other investments serviced by affiliates of
                    <span style="white-space: nowrap">T. Rowe Price</span> Advisory Services such as workplace retirement account(s), and trust account(s).`,
        prospContentSub: `Please note that certain types of accounts that you
                may control, like irrevocable trusts or corporate accounts, cannot be included in your Plan. Other types of accounts, like workplace retirement accounts,
                can be included in the Plan but are not eligible for discretionary management. Please note that the only type of trust that we can provide advice for are
                certain revocable trusts. Please discuss with your financial advisor if you have questions.`,
        prospContentSubSub: `By clicking the checkbox(es) below, I authorize investment holdings
                information from my workplace retirement account(s) and/or trust account(s) to be included in the <span style="font-weight: bold">Plan</span> to the extent this account/these accounts are serviced
                by affiliates of <span style="white-space: nowrap">T. Rowe Price</span> Advisory Services.`,
    },
    checkboxLabel:
        'I confirm that I have reviewed the accounts that will be included in this Plan and they are correct.',
    aggregationSection: {
        header: `Aggregation Services to Add Outside Investment Account(s)`,
        content: `By selecting the "I agree" checkbox below, I elect to use the aggregation services to include my outside investment accounts in the Plan and in any
                interactive educational tools offered in the Retirement Advisory Service and be bound by the Service Terms as described below.`,
        subHeader: 'Important Information',
        contentSub: `The services, which are connected by Yodlee, allow you to include financial accounts you hold outside of
                    <span style="white-space: nowrap">T. Rowe Price</span> in your Plan and in any interactive educational tools offered in the Retirement Advisory Service.`,
        bulletPoints: [
            {
                bullet: `Yodlee obtains data (such as balances and transactions) for the accounts you link each time you log in to
                        <span style="white-space: nowrap">T. Rowe Price</span> so that your data can be made available to you for the services. Yodlee also obtains
                        your data if you use other tools provided and operated by Yodlee.`,
                bulletKey: 'bullet-1',
            },
            {
                bullet: `Yodlee and <span style="white-space: nowrap">T. Rowe Price</span> have the right to use your data to provide and improve the services.`,
                bulletKey: 'bullet-2',
            },
            {
                bullet: `Yodlee and <span style="white-space: nowrap">T. Rowe Price*</span> also have the right to de-identify your data, take steps to ensure it
                        cannot be reasonably linked back to you, and then use or disclose the de-identified data.`,
                bulletKey: 'bullet-3',
            },
        ],
        notice: `*In cases when <span style="white-space: nowrap">T. Rowe Price</span> is making the Yodlee services available to you as part of an
                    employer-sponsored retirement plan in which you participate,
                    <span style="white-space: nowrap">T. Rowe Price</span> will handle your data in accordance with its responsibilities to the plan sponsor.`,
        serviceContent: `Please read the <a href=${aemPdfLinks.aggregationServiceTermsLink} target="_blank" rel="noopener noreferrer" style="text-decoration: underline;
                    color: #086EA1">Service Terms</a> carefully as they include these and other terms and conditions for the services,
                    including potential risks associated with using the services. By selecting the “I agree” checkbox below, you are electing to use
                    the services and be bound by the Service Terms.`,
        aggregationTerms: `If you want to include your outside investment account(s) using the aggregation services, you can click 'I agree' and then 'Continue' below.
                    This is optional and you can manually enter outside investment account(s) into your Plan, as well.`,
    },
    serviceTerms: {
        contentHeader: `The services, which are connected by Yodlee, allow you to include financial accounts you hold outside of
                <span style="white-space: nowrap">T. Rowe Price</span> in your Plan and in any interactive educational tools offered in the Retirement Advisory Service.`,
        firstTerm: `Yodlee obtains data (such as balances and transactions) for the accounts you link each time you log in
                to <span style="white-space: nowrap">T. Rowe Price</span> so that your data can be made available to you for the services.
                Yodlee also obtains your data if you use other tools provided and operated by Yodlee.`,
        secondTerm: `Yodlee and <span style="white-space: nowrap">T. Rowe Price</span> have the right to use your data to provide and improve the services.`,
        thirdTerm: `Yodlee and <span style="white-space: nowrap">T. Rowe Price*</span> also have the right to de-identify your data, take steps to ensure it cannot be
                reasonably linked back to you, and then use or disclose the de-identified data.`,
    },
    closingSection: `If you do not want to include your workplace retirement account(s) and/or trust account(s) in your Plan, click
        'Continue' below without those boxes checked. You can always manually enter your account(s) into your Plan.`,
};
